import { ESuggestType } from '@cian/geosuggest-widget';

import { EGeoSearchTypes } from '../constants';
import { EGeoTypes } from '../constants/geoTypes';
import { IGeoStep } from '../types';
import { EStepField } from '../constants/stepField';
import { NBSP } from '../../../constants/symbols';

export const getExtraSteps = (searchType: EGeoSearchTypes): IGeoStep[] => {
  switch (searchType) {
    case EGeoSearchTypes.REGION:
      return [
        {
          field: EStepField.area,
          title: `Какие районы вам${NBSP}подходят?`,
          types: [ESuggestType.city, ESuggestType.district, ESuggestType.road],
          placeholder: 'Населённый пункт, район или шоссе',
          placeholderExtra: 'Выберите еще населённый пункт, район или шоссе',
        },
      ];
    case EGeoSearchTypes.REGION_WITH_UNDERGROUND:
      return [
        {
          field: EStepField.area,
          title: `Какие районы вам${NBSP}подходят?`,
          types: [ESuggestType.city, ESuggestType.district, ESuggestType.road, ESuggestType.underground],
          placeholder: 'Населённый пункт, метро, район или шоссе',
          placeholderExtra: 'Выберите еще населённый пункт, метро, район или шоссе',
        },
      ];
    case EGeoSearchTypes.CITY_WITH_DISTRICTS_UNDERGROUND:
      return [
        {
          field: EStepField.districts,
          title: `Какие районы вам${NBSP}подходят?`,
          types: [ESuggestType.district],
          placeholder: 'Название района',
          placeholderExtra: 'Выберите еще район',
        },
        {
          field: EStepField.undergrounds,
          title: 'Метро рядом',
          types: [ESuggestType.underground],
          placeholder: 'Станция метро',
          placeholderExtra: 'Выберите еще станцию',
        },
      ];
    case EGeoSearchTypes.CITY_WITH_DISTRICTS:
      return [
        {
          field: EStepField.districts,
          title: `Какие районы вам${NBSP}подходят?`,
          types: [ESuggestType.district],
          placeholder: 'Название района',
          placeholderExtra: 'Выберите еще район',
        },
      ];
    case EGeoSearchTypes.CITY:
      return [
        {
          field: EStepField.streets,
          title: `А на какой улице?`,
          types: [EGeoTypes.street],
          placeholder: 'Введите здесь',
          placeholderExtra: 'Выберите еще улицу',
        },
      ];
    default:
      return [];
  }
};
